import { ArrayUtils } from '@shopping/common'
import { CommonState } from 'common/types'
import { ChannelParams } from 'common/types/params'
import { StateKey } from 'common/utils/flipState'
import { StoreState } from 'common/types/state'
import { fetchChannels } from 'common/services/channel'
import history, { getLocationPath } from 'common/history'
import { fetchStoreZzims } from 'common/services/zzim'
import { isEmptyObject } from 'common/utils/logic/object'

const DISPLAY_STORE_COUNT = 10

const initialState: StoreState = {
  channels: [],
  page: 0,
  hasMore: false,
  totalCount: 0,
  params: {},
}

const FETCH = 'store/FETCH'
const FETCH_SHUFFLE = 'store/FETCH_SHUFFLE'

export const fetchStores = (curState: StateKey, params: ChannelParams, stacked?: boolean) => async (
  dispatch,
  getState: () => CommonState,
) => {
  const mergedParams: ChannelParams = {
    ...getState().stores[curState].params,
    ...params,
  }

  const restoredState = getStoresFromHistoryState()
  if (restoredState) {
    const { channels } = restoredState
    if (ArrayUtils.isNotEmpty(channels)) {
      const ids = channels.map(channel => channel._id)
      const storeZzims = await fetchStoreZzims(ids, null)
      if (!isEmptyObject(storeZzims)) {
        channels.forEach(channel => (channel.zzim = storeZzims[channel._id]))
      }
    }
    dispatch({
      curState,
      mergedParams,
      state: restoredState,
      type: FETCH,
    })
    return
  }

  const prevStoreState = getState().stores[curState]
  const storeState = await fetchChannels(mergedParams)

  storeState.channels = stacked
    ? storeState.page === 1
      ? storeState.channels
      : [...prevStoreState.channels, ...storeState.channels]
    : storeState.channels
  storeState.totalCount = storeState.page === 1 ? storeState.totalCount : prevStoreState.totalCount
  storeState.pageCount = storeState.page === 1 ? storeState.pageCount : prevStoreState.pageCount

  dispatch({
    curState,
    mergedParams,
    state: storeState,
    type: FETCH,
  })
}

const getStoresFromHistoryState = (): StoreState => {
  if (history.location && history.location.state && history.location.state.stores) {
    const stores = history.location.state.stores
    history.replace(getLocationPath(location), { ...history.location.state, stores: null })
    return stores
  }
}

export const fetchShuffleStores = (curState: StateKey, params: ChannelParams) => async (
  dispatch,
  getState: () => CommonState,
) => {
  const mergedParams: ChannelParams = {
    ...getState().stores[curState].params,
    ...params,
  }

  const restoredState = getStoresFromHistoryState()
  if (restoredState) {
    dispatch({
      curState,
      mergedParams,
      state: restoredState,
      type: FETCH_SHUFFLE,
    })
    return
  }

  const storeState = await fetchChannels(mergedParams)
  if (storeState.channels) {
    storeState.channels = ArrayUtils.shuffle(storeState.channels).slice(0, DISPLAY_STORE_COUNT)
  }

  dispatch({
    curState,
    mergedParams,
    state: storeState,
    type: FETCH_SHUFFLE,
  })
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH:
    case FETCH_SHUFFLE:
      return {
        ...initialState,
        ...action.state,
        params: action.mergedParams,
      }
    default:
      return state
  }
}

export default reducer
